<template>
    <div class="similar_row">
        <nuxt-link
            v-if="!isExternalLink"
            :to="internalLink"
            class="article_link"
        >
            <h3>{{ name }}</h3>
            <p v-if="item.description">{{ item.description }}</p>
        </nuxt-link>

        <a
            v-else
            v-bind="additionalAttributes"
            :href="externalLink"
            class="article_link"
        >
            <h3>{{ name }}</h3>
            <p v-if="item.description">{{ item.description }}</p>
        </a>
    </div>
</template>
<script>
import SimilarItemBase from './SimilarItemBase';

export default {
    extends: SimilarItemBase
};
</script>
